const config = {
  siteTitle: 'Tarun Sharma',
  siteUrl: 'https://design.tkssharma.com',
  siteLogo: '/logo.png',
  description:
    'Software engineer and open source creator. This is my digital garden.',
}

export default config
